import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const ArrowRightIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <mask
                id="mask0_4933_58039"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_4933_58039)">
                <path
                    d="M13.3 17.2998L8.70005 12.6998C8.60005 12.5998 8.52938 12.4915 8.48805 12.3748C8.44605 12.2581 8.42505 12.1331 8.42505 11.9998C8.42505 11.8665 8.44605 11.7415 8.48805 11.6248C8.52938 11.5081 8.60005 11.3998 8.70005 11.2998L13.3 6.6998C13.4834 6.51647 13.7167 6.4248 14 6.4248C14.2834 6.4248 14.5167 6.51647 14.7 6.6998C14.8834 6.88314 14.975 7.11647 14.975 7.3998C14.975 7.68314 14.8834 7.91647 14.7 8.0998L10.8 11.9998L14.7 15.8998C14.8834 16.0831 14.975 16.3165 14.975 16.5998C14.975 16.8831 14.8834 17.1165 14.7 17.2998C14.5167 17.4831 14.2834 17.5748 14 17.5748C13.7167 17.5748 13.4834 17.4831 13.3 17.2998Z"
                    fill={color}
                />
            </g>
        </svg>
    );
};

export default React.memo(ArrowRightIcon);
